import { createAsyncThunk } from "@reduxjs/toolkit";
import { Auth, CognitoUser } from "@aws-amplify/auth";

export const authenticate = createAsyncThunk("auth/authenticate", async (expired: boolean) => {
    try {
        const cognitoUser = await Auth.currentAuthenticatedUser();

        const userAttributes = JSON.parse(JSON.stringify(cognitoUser.attributes));
        const userIdentity = JSON.parse(userAttributes.identities)[0];

        const currentSession = expired
            ? await refreshSession(cognitoUser)
            : cognitoUser.signInUserSession;
        const userSession = JSON.parse(JSON.stringify(currentSession));
        const idToken = userSession.idToken;

        return {
            isAuthenticated: true,
            jwtToken: idToken.jwtToken,
            expiration: idToken.payload["exp"],
            user: {
                alias: userIdentity.userId,
                identity: userAttributes.sub,
                firstName: userAttributes.given_name,
                lastName: userAttributes.family_name,
                fullName: `${userAttributes.given_name} ${userAttributes?.family_name}`,
                email: userAttributes.email,
            },
        };
    } catch (e) {
        Auth.federatedSignIn({
            customProvider: "AmazonFederate",
        });
    }
});

export const refreshSession = async (user: CognitoUser) => {
    const session = await Auth.currentSession();

    return new Promise(resolve =>
        user.refreshSession(session.getRefreshToken(), (err, refreshedSession) =>
            resolve(refreshedSession)
        )
    );
};
